// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <div id="health" />
      <h2 id="december-4%2C-2018">December 4, 2018</h2>
      <p>Launch of the Veterans Health API</p>
      <ul>
      <li>Available for development environment access.</li>
      </ul>
    </div>
  );
};

export default MarkdownComponent;
